import { render, staticRenderFns } from "./OutBounds.vue?vue&type=template&id=90ce6f12&scoped=true&"
import script from "./OutBounds.vue?vue&type=script&lang=js&"
export * from "./OutBounds.vue?vue&type=script&lang=js&"
import style0 from "./OutBounds.vue?vue&type=style&index=0&id=90ce6f12&scoped=true&lang=scss&"
import style1 from "./OutBounds.vue?vue&type=style&index=1&id=90ce6f12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90ce6f12",
  null
  
)

export default component.exports